module.exports = __webpack_public_path__ + "img/eat_out_18.509669a1.jpg";